export default __webpack_public_path__ + "static/media/endRound9.d844a237.mp3";